import React, { useEffect, useState } from 'react'
import Footer from '../Footer/Footer.js';


const GradeLessons = ({id}) => {
    const [data, setData] = useState([])
    const [grade,setGrade] = useState('')

    useEffect(() => {
        fetch(`https://englishtutorial1.somee.com/api/Lessons?GradeId=${id}`)
            .then(json => json.json())
            .then(result => {
                setGrade(result[0].GradeName)
                return result.reduce((obj,item)=>{
                    if(!(item.CatName in obj)){
                        obj[item.CatName]=[]
                    }else{
                        obj[item.CatName].push(item)
                    }
                    return obj;
                },{})
            })
            .then(obj=>{
                setData(obj)
            })
    }, [id])


    return (
        <>
        <div style={{ marginTop: "10rem",marginBottom: "5rem"}}>
            <h1 style={{ textAlign:'center' }}>{grade}</h1>
                {
                    Object.keys(data).map(key=>
                        <LessonCategories header={key} data={data[key]} />                       
                    )
                }
        </div>
        <div style={{position:'absolute', bottom: 0,width:'100%'}}><Footer /></div>
        </>
    )
}

function LessonCategories({header,data}){
    return(
        <>
         <h3>{header}</h3>
            <div style={{display:'flex',flexWrap:'wrap'}}> 
                {data.map(item => 
                    <div style={{ border:'1px solid black', margin:'5px', width:'200px'}}>
                        <div><a href={item.LessonUrl} target="_blank"> {item.LessonName} </a> </div>
                    </div>
                )}
            </div>
        </>
    )
}



export default GradeLessons
